import { render, staticRenderFns } from "./PedidoAcumuladoVsDespachado.vue?vue&type=template&id=8f1e6b54&scoped=true"
import script from "./PedidoAcumuladoVsDespachado.vue?vue&type=script&lang=js"
export * from "./PedidoAcumuladoVsDespachado.vue?vue&type=script&lang=js"
import style0 from "./PedidoAcumuladoVsDespachado.vue?vue&type=style&index=0&id=8f1e6b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1e6b54",
  null
  
)

export default component.exports